import React, { useState, useEffect } from 'react';

const MultipleAnswers = ({
  questionNumber = "",
  question = "",
  answers = [],
  correctAnswer = [],
  onCalculateScore
}) => {
  const [selectedAnswers, setSelectedAnswers] = useState([]);

  useEffect(() => {
    onCalculateScore(2, questionNumber, selectedAnswers, correctAnswer);
  }, [selectedAnswers]);


  const handleAnswerClick = (index) => {
    const letter = String.fromCharCode(65 + index); // Convert index to letter (A-Z)

    setSelectedAnswers((prevSelected) => {
      let updatedSelected;
      if (prevSelected.includes(letter)) {
        updatedSelected = prevSelected.filter(l => l !== letter);
      } else {
        // Check if the number of selected answers is less than the correctAnswer size
        if (prevSelected.length < correctAnswer.length) {
          updatedSelected = [...prevSelected, letter];
        } else {
          updatedSelected = prevSelected;
        }
      }

      return updatedSelected;
    });
  };

  return (
    <div className="w-full bg-white p-3 text-sm font-inter text-black">
      {/* Question Number */}
      <div className="py-1 w-full mb-1">
        <b>{questionNumber}.</b><span className="ml-2"></span>{question}
      </div>

      {answers.map((answer, index) => {
        const letter = String.fromCharCode(65 + index); // A-Z based on index
        const isSelected = selectedAnswers.includes(letter);
        return (
          <div
            key={index}
            className={`flex items-center gap-2 mb-1 cursor-pointer ${isSelected ? 'bg-blue-100' : ''}`}
            onClick={() => handleAnswerClick(index)}
          >
            <div
              className={`w-3 h-3 flex items-center justify-center border border-gray-500 text-xs font-semibold ${isSelected ? 'bg-blue-500 text-white' : 'bg-white'}`}
            >
              {isSelected && (
                <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
                </svg>
              )}
            </div>
            <span>{answer}</span>
          </div>
        );
      })}
    </div>
  );
};

export default MultipleAnswers;